import { createBrowserRouter } from 'react-router-dom';
import {
  HomePage,
  AnalysisViewerPage,
  InsightsPage,
  DeckPlanPage,
  RiskAssessmentPage,
  IDMSPage,
  InspectionPage,
  EsSheetPage,
  TemplateBuilderViewPage,
  TemplateBuilderListPage,
  UserManagementPage,
  UserProfilePage,
  PlatformAssetsPage,
  BenchmarkPage,
  SystemTest,
  ErrorPage,
  TempAuth0Redirect,
  AssetLabellingDefaultPage,
} from '@/pages';
import { ReportsIndexPage } from '@/pages/analysis/reports/reports-index';
import { ReportsViewPage } from '@/pages/analysis/reports/reports-view';
import { TasksPage } from '@/pages/inspection/tasks';
import { PlatformsPage } from '@/pages/platforms';
import ViewerPage from '../pages/asset-labelling/viewer';
import { ErrorScreen } from '../components/shared/ErrorScreen';

const ErrorBoundary = () => {
  return <ErrorScreen statusCode="" errorMessage="Something went wrong" />;
};

export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: 'analysis/:inspection/',
        element: <AnalysisViewerPage />,
      },
      {
        path: 'analysis/:inspection/insights',
        element: <InsightsPage />,
      },
      {
        path: 'analysis/:inspection/viewer',
        element: <AnalysisViewerPage />,
      },
      {
        path: 'analysis/:inspection/deckplan',
        element: <DeckPlanPage />,
      },
      {
        path: 'analysis/:inspection/idms',
        element: <IDMSPage />,
      },
      {
        path: 'analysis/:inspection/risk',
        element: <RiskAssessmentPage />,
      },
      {
        path: 'analysis/:inspection/reports',
        element: <ReportsIndexPage />,
      },
      {
        path: 'analysis/:inspection/reports/:reportid',
        element: <ReportsViewPage />,
      },
      {
        path: 'asset-labelling/:inspection/viewer',
        element: <ViewerPage />,
      },
      {
        path: 'asset-labelling/:inspection',
        element: <AssetLabellingDefaultPage />,
      },
      {
        path: 'inspection/:inspection',
        element: <InspectionPage />,
      },
      {
        path: 'inspection/:inspection/tasks',
        element: <TasksPage />,
      },
      {
        path: '/es-sheet/:platformId',
        element: <EsSheetPage />,
      },
      {
        path: '/template-builder',
        element: <TemplateBuilderViewPage />,
      },
      {
        path: '/template-builder/:structure',
        element: <TemplateBuilderListPage />,
      },
      {
        path: '/userManagement/main',
        element: <UserManagementPage />,
      },
      {
        path: '/userManagement/user/:userid',
        element: <UserProfilePage />,
      },
      {
        path: '/platforms',
        element: <PlatformsPage />,
      },
      {
        path: '/platform-assets/:platformId',
        element: <PlatformAssetsPage />,
      },
      {
        path: '/benchmark',
        element: <BenchmarkPage />,
      },
      {
        path: '/system-test',
        element: <SystemTest />,
      },
      {
        path: '/error',
        element: <ErrorPage />,
      },
      {
        path: '*',
        element: <ErrorPage />,
      },
      {
        path: 'api/auth/callback',
        element: <TempAuth0Redirect />,
      },
    ],
  },
]);
